export const DEFAULT_LANGUAGE = 'ko';
export const REQUEST_ORIGINAL_CONTENT_KEY = 'original';
